<template>
  <div v-if="fullDataStructure">
    <div v-if="currentQuestionIndex < 0 || currentQuestionIndex >= fullDataStructure.Questions.length" id="waiting-page">
      <video autoplay muted loop>
        <source src="../assets/media/idle.mp4" type="video/mp4">
        Your browser does not support the video tag.
      </video>
    </div>
    <div v-else-if="currentQuestionIndex < fullDataStructure.Questions.length && currentQuestionIndex >= 0" class="border-color-primary" id="preview-screen-specialist" :style="{backgroundColor:fullDataStructure.Questions[currentQuestionIndex].background_color, position: 'relative'}">
      <div
        v-for="(element, index2) in fullDataStructure.Questions[currentQuestionIndex].Elements" :key="`element-${index2}`"
        :style="{
          top: `${element.styles.top}px`,
          left: ` ${element.styles.left}px`,
          width: `${element.styles.width}px`,
          height: `${element.styles.height}px`,
          backgroundColor: element.styles.backgroundColor,
          zIndex: element.styles.zIndex,
          fontSize: `${element.styles.fontSize}px`,
          position: 'absolute'
        }"
        class="resizable-button-container"
      >
        <img v-if="element.image != ''" :src="`${reverseProxy}/api/${element.image}`" width="100%" height="100%">
        <div class="placeholder-rect">{{ element.content }}</div>
      </div>
    </div>
  </div>
</template>

<script>
  import instance from '../axios.js';

  export default {
    data() {
      return {
        reverseProxy: process.env.VUE_APP_REVERSE_PROXY_ENDPOINT,
        applicationID: null,
        fullDataStructure: null,
        currentQuestionIndex: -1,
        channel: null,
      }
    },
    async created() {
      try {
        this.applicationID = this.$route.params.applicationID;
        let fullDataStructureResponse = await instance.get(`/api/appAdmin/application/structure/${this.applicationID}`);
        this.fullDataStructure = fullDataStructureResponse.data;

        this.fullDataStructure.Questions.sort((a, b) => a.question_order - b.question_order);
        this.currentQuestionIndex = this.$route.query.startingIndex;

        for (let i = 0; i < this.fullDataStructure.Questions.length; i++) {
          for (let j = 0; j < this.fullDataStructure.Questions[i].Elements.length; j++) {
            this.fullDataStructure.Questions[i].Elements[j].styles = JSON.parse(this.fullDataStructure.Questions[i].Elements[j].styles)
            this.fullDataStructure.Questions[i].Elements[j].events_actions = JSON.parse(this.fullDataStructure.Questions[i].Elements[j].events_actions)
          }
        }

        this.setUpBroadCast();
        this.formatForNewResolution('preview-screen-specialist');
      } catch (e) {
        console.error(e);
      }
    },
    methods: {
      getImageFileSrc(imageDetailObject) {
        if (imageDetailObject.fileRef != null && imageDetailObject.fileRef != "") {
          return imageDetailObject.fileRef;
        } else if (imageDetailObject.file != null) {
          return URL.createObjectURL(imageDetailObject.file);
        } else {
          return null;
        }
      },
      formatForNewResolution(elementID) {
        this.$nextTick(() => {
          let currentQuestionInstance = this.fullDataStructure.Questions[this.currentQuestionIndex];
          let [originalWidth, originalHeight] = currentQuestionInstance.child_view_original_screen_resolution.split('x').map(Number);
          let newWidth = document.getElementById(elementID).offsetWidth;
          let newHeight = document.getElementById(elementID).offsetHeight;
          if (newWidth == originalWidth && newHeight == originalHeight) {
            return;
          }

          //[x,y] transform coordinates from original to new resolution
          let xTransform = newWidth / originalWidth;
          let yTransform = newHeight / originalHeight;

          for (let i = 0; i < currentQuestionInstance.Elements.length; i++) {
            currentQuestionInstance.Elements[i].styles.left *= xTransform;
            currentQuestionInstance.Elements[i].styles.top *= yTransform;
            currentQuestionInstance.Elements[i].styles.height *= yTransform;
            currentQuestionInstance.Elements[i].styles.width *= xTransform;
          }

          currentQuestionInstance.child_view_original_screen_resolution = `${newWidth}x${newHeight}`;
        });
      },
      setUpBroadCast() {
        this.channel = new BroadcastChannel(`${this.applicationID}`);

        this.channel.addEventListener('message', this.receiveChannelMessage);
      },
      receiveChannelMessage(event) {
        if (event.data.action == 'changeIndex') {
          this.currentQuestionIndex = event.data.data;
          this.formatForNewResolution('preview-screen-specialist');
        }
      },
      sendChannelMessage(message) {
        this.channel.postMessage(message);
      }
    },
    beforeDestroy() {
      this.channel.removeEventListener('message', this.sendChannelMessage);
      this.channel.close();
    }
  }
</script>

<style lang="scss" scoped>
  @use 'sharedSCSS/globalSharedVariables';
  $reportOrange: #FF9B00;
  $reportOrangeLight: #eecc9a;

  #waiting-page {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100dvh;

    video {
      position: fixed;
      top: 0;
      left: 0;
      width: 100dvw;
      height: 100dvh;
      object-fit: cover;
    }
  }

  .border-color-primary {
    border: solid 2px $reportOrange;
    width: 100%;
    height: 100dvh;
    position: relative;

    > div {
      position: absolute;
    }

    .resizable-button-container {
      $local-border-radius: 1rem;

      position: absolute;
      border-radius: $local-border-radius;
      box-shadow: 0 0 5px 5px lightgrey;
      border: solid black 1px;
      user-select: none;
      cursor: pointer;
      
      .placeholder-rect {
        position: absolute;
        top: 0;
        left: 0;
        word-wrap: break-word;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      img {
        border-radius: $local-border-radius;
      }
    }
  }
</style>